import React from 'react';

export default props =>
  props.product.calory || props.product.allergies ? (
    <ul tabIndex={0}>
      {props.product.calory ? (
        <li>{props.product.calory.substring(0, 9)} kCal</li>
      ) : null}
      {props.product.allergies ? (
        <li>Allergens: {props.product.allergies}</li>
      ) : null}
    </ul>
  ) : null;



// WEBPACK FOOTER //
// ./src/containers/Menu/MenuComponents/Products/ProductDetails/NutritionFacts.js